<template>
    <div class="mt-3 col-12 col-md">
        <b-card no-body class="text-center bg-gradient-gray p-2">
            <b-badge style="z-index: 2;">{{titulo}}</b-badge>
            <img src="@/assets/images/lines.svg" class="card-img-absolute" alt="circle-image"/>
            <div class="mt-2 h3 text-blue-400" style="z-index: 2;" v-if="!editar">{{valor}}</div>
            <input-money v-model="valor" class="mt-2 mb-0 input-money-card color-blue-400" v-if="editar"/>
        </b-card>
    </div>
</template>
<script>
import InputMoney from "@/components/inputs/InputMoney";
export default {
    props: {
        titulo: {
            required: true,
        },
        value: {
            required: true,
        },
        editar: {
            default: false,
        },
    },
    components: {
        InputMoney
    },
    data : () => ({
        valor: 0,
    }),
    watch: {
        value : {
            handler: function(valor) {
                this.valor = valor;
            },
            immediate: true,
        },
        valor(valor) {
            this.$emit('input', valor);
        }
    },
}
</script>
<style lang="scss">
    .input-money-card .form-control {
        border: none;
        border-bottom: 1px solid #666;
        border-radius: 0px !important;
        text-align: right;
        font-weight: 800;
        font-size: 20px;
    }
</style>